import { ProtectedHttpClient } from '@/core/http';
import {
  MockHttpNotificationRepository,
  NotificationRepository,
} from '@/modules/Notifications/repositories';
import { RequestRepository } from '@/modules/Requests/repositories';
import { SyncStatusRepository } from '@/modules/Sync/repositories';
import { UserRepository } from '@/modules/Users/repositories';

// HTTP Clients
const usersClient = new ProtectedHttpClient('users');
const notificationsClient = new ProtectedHttpClient('notifications');
const requestsClient = new ProtectedHttpClient('requests');
const syncStatusClient = new ProtectedHttpClient('sync');

// Create repositories
export const usersRepo = new UserRepository(usersClient);
export const notificationsRepo = new NotificationRepository(
  notificationsClient,
);
export const requestsRepo = new RequestRepository(requestsClient);
export const syncStatusRepo = new SyncStatusRepository(syncStatusClient);

// Create Mock repositories
export const mockNotificationsRepo = new MockHttpNotificationRepository();
